var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kimia",attrs:{"id":"kimia"}},[_c('Head',{staticClass:"kimia__content"}),_c('Footer',{staticClass:"kimia__footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }